import BaseService from "@/boot/BaseService";
class AlicuotaService extends BaseService {
  constructor() {
    super(null, "/alicuotas");
  }
  async index() {
    return await this.get("/");
  }
}

export default new AlicuotaService();
